import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import AuthService from '@/services/AuthService';
import { LoginResponse } from '@/types/store/auth/LoginResponse';
import { UserInfos } from '@/types/store/auth/UserInfos';
import { AdminInfos } from '@/types/store/auth/AdminInfos';
import AccountType from '@/types/enums/AccountType';
const storedUser = sessionStorage.getItem('user');
@Module({ namespaced: true })
class Auth extends VuexModule {
  public status = storedUser ? { loggedIn: true } : { loggedIn: false };
  public user = storedUser ? JSON.parse(storedUser) : null;
  @Mutation
  public loginSuccess(user: LoginResponse): void {
    this.status.loggedIn = true;
    this.user = user;
  }
  @Mutation
  public loginFailure(): void {
    this.status.loggedIn = false;
    this.user = null;
  }
  @Mutation
  public logout(): void {
    this.status.loggedIn = false;
    this.user = null;
  }
  @Action({ rawError: true })
  login(data: UserInfos): Promise<LoginResponse> {
    return AuthService.login(data).then(
      (user) => {
        this.context.commit('loginSuccess', user);
        return Promise.resolve(user);
      },
      (error) => {
        this.context.commit('loginFailure');
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  }
  @Action({ rawError: true })
  loginAdmin(data: AdminInfos): Promise<LoginResponse> {
    return AuthService.loginAdmin(data).then(
      (user) => {
        this.context.commit('loginSuccess', user);
        return Promise.resolve(user);
      },
      (error) => {
        this.context.commit('loginFailure');
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  }
  @Action
  signOut(): void {
    AuthService.logout();
    this.context.commit('logout');
  }
  get isLoggedIn(): boolean {
    return this.status.loggedIn;
  }
  get accountType(): AccountType | undefined {
    if (this.user !== null) {
      switch (this.user.role) {
        case undefined:
          return AccountType.User;
        case 'admin':
          return AccountType.Admin;
        case 'distributeur':
          return AccountType.Distributor;
      }
    }
  }
}
export default Auth;
